import { CourseProgressTrackerState } from './index.d';

export const CourseProgressTracker: CourseProgressTrackerState = {
  id: '',
  userId: '',
  programId: '',
  batchId: '',
  generateProgramCertificate: false,
  certificateGeneratedCourses: [],
  unitTracks: {},
  chapterTracks: {},
  chapterVideoTracks: {},
  assignmentTracks: {},
  courseTracks: {},
  moduleTracks: {},
  projectTracks: {},
  quizTracks: {},
  videoTracks: {},
  programTracks: {}
};
